import { get, includes } from 'lodash';
import Role from '../../Constants/roles.ts';

export default function showApproveReject(vendor, user) {
  return (
    !vendor.internal_id &&
    vendor.submitted_at &&
    !vendor.approved_at &&
    includes([Role.COMPLIANCE, Role.ADMIN], get(user, 'role'))
  );
}
